<template>
  <div style="text-align: center">
    <div :class="{ short: isShort }">
      {{ qtyScanned }}
    </div>
    <div v-if="isPublishedShort" style="white-space: nowrap">
      ({{ qtyPublishedShort }} short)
    </div>
  </div>
</template>

<script>
import { cbQtyText } from '@/utils';
export default {
  name: 'tdQtyScanned',
  props: ['row'],
  computed: {
    qtyScanned() {
      return cbQtyText(this.row.boxesScanned, 0, 0, true, true, false);
    },
    isShort() {
      return (
        this.row.boxesScanned < this.row.boxesRequested && !this.row.publishedAt
      );
    },
    qtyPublishedShort() {
      return cbQtyText(
        this.row.casesShort,
        this.row.bottlesShort,
        0,
        true,
        true,
        false
      );
    },
    isPublishedShort() {
      return this.row.casesShort > 0 || this.row.bottlesShort > 0;
    },
  },
};
</script>

<style scoped>
.short {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderTable/components/tdQtyScanned.vue